(function () {
  'use strict';

  function boot() {
    if (window.LumeHomeEditable) {
      return;
    }

    var instances = new Map();

    function init(root) {
      if (!root || !root.matches('[data-lume-home-editable]')) return;
      if (instances.has(root)) return;

      var cleanups = [];
      var timers = [];
      var intervals = [];
      var observers = [];
      var reducedQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      var reduced = !!(reducedQuery && reducedQuery.matches);
      var destroyed = false;

      function on(target, event, handler, options) {
        if (!target || !target.addEventListener) return;
        target.addEventListener(event, handler, options);
        cleanups.push(function () { target.removeEventListener(event, handler, options); });
      }
      function later(callback, delay) {
        var id = window.setTimeout(function () { if (!destroyed) callback(); }, delay);
        timers.push(id);
        return id;
      }
      function repeat(callback, delay) {
        var id = window.setInterval(callback, delay);
        intervals.push(id);
        return id;
      }
      function play(video, userInitiated) {
        if (!video || (reduced && !userInitiated)) return;
        var promise = video.play();
        if (promise && promise.catch) promise.catch(function () {});
      }
      function reveal(node) {
        node.classList.add('in', 'lh-vx-in');
        if (node.classList.contains('lh-imgbrk')) node.classList.add('lh-gua-in', 'lh-guasha-ready');
      }
      function hydrate(video, shouldPlay, userInitiated) {
        var hydrated = false;
        var sources = video ? Array.prototype.slice.call(video.querySelectorAll('source[data-src]')) : [];
        sources.forEach(function (source) {
          if (source.getAttribute('src')) return;
          source.setAttribute('src', source.getAttribute('data-src'));
          hydrated = true;
        });
        if (hydrated) video.load();
        if (shouldPlay) play(video, userInitiated);
      }

      root.classList.add('is-loaded', 'lh-vx-motion-ready');
      root.classList.toggle('lh-reduced-motion', reduced);

      var revealNodes = Array.prototype.slice.call(root.querySelectorAll('[data-lh-anim],.lh-reveal-batch,[data-lh-vx-reveal]'));
      if (reduced || !('IntersectionObserver' in window)) {
        revealNodes.forEach(reveal);
      } else {
        var revealObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            reveal(entry.target);
            revealObserver.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
        observers.push(revealObserver);
        revealNodes.forEach(function (node) { revealObserver.observe(node); });
      }

      var product = root.querySelector('.lh-prod');
      var toggleButtons = Array.prototype.slice.call(root.querySelectorAll('[data-lh-prod-mode]'));
      var techFields = Array.prototype.slice.call(root.querySelectorAll('[data-lh-type]'));
      function resetTech() {
        techFields.forEach(function (field) {
          var full = field.getAttribute('data-lh-full') || field.getAttribute('data-lh-type') || field.textContent || '';
          field.setAttribute('data-lh-full', full);
          field.textContent = full;
          field.classList.remove('is-typing');
        });
      }
      function typeTech() {
        resetTech();
        if (reduced) return;
        techFields.forEach(function (field, index) {
          var full = field.getAttribute('data-lh-full') || '';
          field.textContent = '';
          field.classList.add('is-typing');
          later(function () {
            var character = 0;
            var id = repeat(function () {
              if (destroyed) return window.clearInterval(id);
              field.textContent = full.slice(0, character++);
              if (character > full.length) {
                window.clearInterval(id);
                later(function () { field.classList.remove('is-typing'); }, 180);
              }
            }, 18);
          }, index * 80);
        });
      }
      function setProductMode(mode) {
        if (!product) return;
        var isTech = mode === 'tech';
        product.classList.toggle('is-tech', isTech);
        toggleButtons.forEach(function (button) {
          var active = button.getAttribute('data-lh-prod-mode') === mode;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        root.querySelectorAll('.lh-prod__tech-copy').forEach(function (copy) {
          copy.setAttribute('aria-hidden', isTech ? 'false' : 'true');
        });
        if (isTech) typeTech(); else resetTech();
      }
      resetTech();
      toggleButtons.forEach(function (button) {
        on(button, 'click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setProductMode(button.getAttribute('data-lh-prod-mode'));
        });
      });

      var wavelengthButtons = Array.prototype.slice.call(root.querySelectorAll('[data-lh-wl-points] .lh-wl__point'));
      var wavelengthPanel = root.querySelector('[data-lh-wl-panel]');
      var wavelengthValue = root.querySelector('[data-lh-wl-value]');
      var wavelengthLabel = root.querySelector('[data-lh-wl-label]');
      var wavelengthCopy = root.querySelector('[data-lh-wl-copy]');
      var activeWavelength = root.querySelector('.lh-wl__point.is-active') || wavelengthButtons[0];
      var tones = { red: { color: '#e10600', glow: 'rgba(225,6,0,.10)' }, 'deep-red': { color: '#8d1d1d', glow: 'rgba(141,29,29,.12)' } };
      function setWavelength(button) {
        if (!button || !wavelengthPanel || button === activeWavelength) return;
        activeWavelength = button;
        wavelengthButtons.forEach(function (item) { item.classList.toggle('is-active', item === button); });
        var apply = function () {
          var tone = tones[button.dataset.tone] || tones.red;
          wavelengthPanel.style.setProperty('--pwc', tone.color);
          wavelengthPanel.style.setProperty('--pwg', tone.glow);
          if (wavelengthValue) wavelengthValue.textContent = button.dataset.value || '';
          if (wavelengthLabel) wavelengthLabel.textContent = button.dataset.label || '';
          if (wavelengthCopy) wavelengthCopy.textContent = button.dataset.copy || '';
          wavelengthPanel.classList.remove('is-switching');
        };
        wavelengthPanel.classList.add('is-switching');
        if (reduced) apply(); else later(apply, 150);
      }
      if (activeWavelength && wavelengthPanel) {
        var initialTone = tones[activeWavelength.dataset.tone] || tones.red;
        wavelengthPanel.style.setProperty('--pwc', initialTone.color);
        wavelengthPanel.style.setProperty('--pwg', initialTone.glow);
      }
      wavelengthButtons.forEach(function (button) {
        on(button, 'mouseenter', function () { setWavelength(button); });
        on(button, 'click', function () { setWavelength(button); });
        on(button, 'focus', function () { setWavelength(button); });
      });

      var videos = Array.prototype.slice.call(root.querySelectorAll('.lh-hero__video,video[data-lh-vx-video]'));
      if (reduced) {
        videos.forEach(function (video) { video.pause(); video.removeAttribute('autoplay'); });
      } else if ('IntersectionObserver' in window) {
        var videoObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { if (entry.isIntersecting) play(entry.target, false); else entry.target.pause(); });
        }, { threshold: 0.16, rootMargin: '80px 0px 80px 0px' });
        observers.push(videoObserver);
        videos.forEach(function (video) { videoObserver.observe(video); });
      } else {
        videos.forEach(function (video) { play(video, false); });
      }

      var socialTrack = root.querySelector('[data-lhv-track]');
      if (socialTrack) {
        var socialVideos = Array.prototype.slice.call(socialTrack.querySelectorAll('video'));
        socialTrack.querySelectorAll('.lhv-card').forEach(function (card) {
          var video = card.querySelector('video');
          var button = card.querySelector('.lhv-play');
          on(button, 'click', function () {
            if (!video.currentSrc) hydrate(video, true, true);
            else if (video.paused) play(video, true);
            else video.pause();
          });
          on(video, 'play', function () { card.classList.add('is-playing'); button.setAttribute('aria-label', 'Pause LUME video'); });
          on(video, 'pause', function () { card.classList.remove('is-playing'); button.setAttribute('aria-label', 'Play LUME video'); });
          on(video, 'ended', function () { card.classList.remove('is-playing'); button.setAttribute('aria-label', 'Play LUME video'); });
        });
        if (!reduced && 'IntersectionObserver' in window) {
          var hydrateObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              socialVideos.forEach(function (video) { hydrate(video, true, false); });
              hydrateObserver.disconnect();
            });
          }, { rootMargin: '320px 0px' });
          observers.push(hydrateObserver);
          hydrateObserver.observe(socialTrack);
        }
      }

      var counters = Array.prototype.slice.call(root.querySelectorAll('[data-lh-vx-count]'));
      function animateCounter(counter) {
        if (counter.dataset.lhVxDone === '1') return;
        counter.dataset.lhVxDone = '1';
        var target = parseFloat(counter.getAttribute('data-lh-vx-count')) || 0;
        var decimals = (String(target).split('.')[1] || '').length;
        if (reduced) { counter.textContent = target.toFixed(decimals); return; }
        var start = performance.now();
        function tick(now) {
          if (destroyed) return;
          var progress = Math.min(1, (now - start) / 950);
          var eased = 1 - Math.pow(1 - progress, 3);
          counter.textContent = (target * eased).toFixed(decimals);
          if (progress < 1) window.requestAnimationFrame(tick);
        }
        window.requestAnimationFrame(tick);
      }
      if (!reduced && 'IntersectionObserver' in window) {
        var countObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            animateCounter(entry.target);
            countObserver.unobserve(entry.target);
          });
        }, { threshold: 0.65 });
        observers.push(countObserver);
        counters.forEach(function (counter) { countObserver.observe(counter); });
      } else {
        counters.forEach(animateCounter);
      }

      var transition = document.querySelector('[data-lh-page-transition]');
      var transitionOwner = transition && transition.closest('[data-lume-home-editable]');
      var transitionTimer = null;
      function hideTransition() {
        if (!transition) return;
        if (transitionTimer) window.clearTimeout(transitionTimer);
        transition.classList.remove('is-visible', 'is-intro');
        if (transitionOwner) transitionOwner.classList.remove('lh-page-is-leaving');
      }
      function shouldTransition(link, event) {
        if (reduced || !link || !link.href || event.defaultPrevented) return false;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
        if (link.target && link.target !== '_self') return false;
        if (link.hasAttribute('download')) return false;
        var href = link.getAttribute('href') || '';
        if (!href || href === '#' || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return false;
        var url;
        try { url = new URL(link.href, window.location.href); } catch (error) { return false; }
        if (url.origin !== window.location.origin) return false;
        if (url.pathname === window.location.pathname && url.hash) return false;
        return !/^\/(cart|checkout|account)(\/|$)/.test(url.pathname);
      }
      hideTransition();
      on(window, 'pageshow', hideTransition);
      on(root, 'click', function (event) {
        var link = event.target.closest && event.target.closest('a');
        if (!transition || !shouldTransition(link, event)) return;
        event.preventDefault();
        transition.classList.add('is-visible');
        if (transitionOwner) transitionOwner.classList.add('lh-page-is-leaving');
        transitionTimer = later(function () { window.location.assign(link.href); }, 280);
      }, true);

      function syncMotion(event) {
        reduced = !!(event ? event.matches : reducedQuery && reducedQuery.matches);
        root.classList.toggle('lh-reduced-motion', reduced);
        if (reduced) {
          videos.forEach(function (video) { video.pause(); });
          revealNodes.forEach(reveal);
          resetTech();
        }
      }
      if (reducedQuery) {
        if (reducedQuery.addEventListener) on(reducedQuery, 'change', syncMotion);
        else if (reducedQuery.addListener) {
          reducedQuery.addListener(syncMotion);
          cleanups.push(function () { reducedQuery.removeListener(syncMotion); });
        }
      }

      function destroy() {
        if (destroyed) return;
        destroyed = true;
        observers.forEach(function (observer) { observer.disconnect(); });
        timers.forEach(window.clearTimeout);
        intervals.forEach(window.clearInterval);
        cleanups.forEach(function (cleanup) { cleanup(); });
        root.querySelectorAll('video').forEach(function (video) { video.pause(); });
        instances.delete(root);
      }

      instances.set(root, { root: root, destroy: destroy });
    }

    function scan(scope) {
      if (scope.matches && scope.matches('[data-lume-home-editable]')) init(scope);
      scope.querySelectorAll('[data-lume-home-editable]').forEach(init);
    }
    function destroyScope(scope) {
      var roots = [];
      if (scope.matches && scope.matches('[data-lume-home-editable]')) roots.push(scope);
      scope.querySelectorAll('[data-lume-home-editable]').forEach(function (root) { roots.push(root); });
      roots.forEach(function (root) {
        var instance = instances.get(root);
        if (instance) instance.destroy();
      });
    }

    window.LumeHomeEditable = { init: init, scan: scan, destroy: destroyScope };
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { destroyScope(event.target); });
    scan(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());
